import { render, staticRenderFns } from "./LabelTypeSelection.vue?vue&type=template&id=5bc3397c&scoped=true"
import script from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LabelTypeSelection.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LabelTypeSelection.vue?vue&type=style&index=0&id=5bc3397c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc3397c",
  null
  
)

export default component.exports